@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.item {
  @include border-radius-r2;
  @include typography-v2-body-sm;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  margin-top: 2px;
  margin-left: 10px;
  padding: 0 4px;
  cursor: pointer;
  color: var(--text-default);
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background-color: var(--surface-hover);

    .dropdownTrigger {
      opacity: 1;
    }
  }

  &.isActive {
    background-color: var(--surface-active);

    .dropdownTrigger {
      opacity: 1;
    }
  }
}

.iconWrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--text-soft);
}

.title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dropdownTrigger {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.1s ease;
  color: var(--text-soft);
}

.dropdownTriggerOpen {
  opacity: 1;
}

.dropdownContent {
  min-width: fit-content;
}

.defaultLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-default);
}

.criticalLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-critical);
}

.tooltipLabel {
  width: 290px;
  @include typography-v2-body-sm;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-soft);
}
